import React, { useEffect, useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { contactTextFn } from '../../flows/shared/utils';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { dispatchOverlayLoad } from '../../analytics/analytics-helper';
import { modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from './style.css';

const UserValidationModal = () => {
  const { closeNextModal } = useContext(FlowContext);

  useEffect(() => {
    // Send analytics the overlay state
    dispatchOverlayLoad('ReviewInformation');
  }, []);

  const modalTitle = `Review and confirm`;

  return (
    <MFBeaconModal open removeCloseButton>
      <span className="modal-close-icon">
        <MFBeaconIconButton
          id="userValidationModalCloseIcon"
          data-name="userValidationModalCloseIcon"
          variant="tertiary"
          onClick={() => modalCloseNextModalHandler(closeNextModal)}
          label="close-button">
          <img slot="icon" src={closeBtn} alt="close icon" />
        </MFBeaconIconButton>
      </span>
      <div className="beacon-modal__title">{modalTitle}</div>
      <div className="beacon-modal__description">
        <p>
          Sorry, we need you to review your information again. Some of the
          details you entered don’t match what we have on file. Here’s what you
          can do:
        </p>
        <p>Go back and provide the correct information</p>
        <p>
          {/* Note: the telephone number in the link below differs for college savings applications.
                    Will need to call mismatchNationalInformation or mismatchAlaskaInformation as applicable
                    when we build those flows  */}
          <a
            className="link-button"
            href={`tel:${contactTextFn('mismatchInformation')(0)}`}>
            Call {contactTextFn('mismatchInformation')(0)}
          </a>
        </p>
        <p>Open your account over the phone</p>
      </div>

      <div slot="action-zone" className="user-validation-btn-container">
        <MFBeaconButton
          noButtonMargin
          variant="primary"
          id="userVerificationRetry"
          data-name="userVerificationRetry"
          onClick={() => modalCloseNextModalHandler(closeNextModal)}
          label="Retry now"
        />
      </div>
      <style jsx>{styles}</style>
    </MFBeaconModal>
  );
};

export default UserValidationModal;
